import PageHeader from "@/components/PageHeader";

export default function LegalPage({ title, subtitle, testId, children }) {
  return (
    <div data-testid={testId}>
      <PageHeader title={title} subtitle={subtitle} testId={`${testId}-title`} />
      <div className="mx-auto max-w-4xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="prose-legal space-y-6 text-[15px] leading-relaxed text-gray-600">
          {children}
        </div>
      </div>
    </div>
  );
}
